import { h, render } from 'preact';

import { PrintState } from '../types/print';
import { View } from '../types/types';
import { Print as PrintComponent } from './components/Print';
import { executePrintJob, getPrintProps } from './props/print';

export class Print {
    constructor() {
        const elements: JQuery = $('.print');

        elements.each((index: number, element: HTMLElement): void => {
            this.init(element);
        });
    }

    init(container: HTMLElement): void {
        const initialState: PrintState = window.initialTicketPrintState;

        const view: View<PrintState> = {
            state: initialState,
            update: (): void => {
                const props = getPrintProps(view);
                render(h(PrintComponent, props), container);
            },
        };

        view.update(); // First render

        if (!initialState.testMode) {
            executePrintJob(view, 'print');
        }
    }
}
